/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import TextCard from "../../../Cards/TextCard/TextCard";
import Container from "../../../Container/Container";

const AttorneyTextCards = () => {
  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextCard
            headingColor={"primary"}
            boxHeading={"Scheidung online - professionelle Beratung durch Scheidungsanwalt inklusive!"}
            boldText={"Wir sind hochqualifizierte Fachanwälte im Familienrecht, deutschlandweit tätig und ermöglichen Ihnen eine professionelle Scheidung!"}
            textAlign={"center"}
          >
            Sie können alles online und per Telefon abklären und sind jederzeit bestens informiert - Ein Besuch beim Scheidungsanwalt vor Ort ist nicht
            notwendig, können wir aber gerne ermöglichen! Sie geben in Ihrer Servicewelt von Legalbird ganz einfach die Daten zu Ihrer Scheidung an und unsere{" "}
            <strong>Scheidungsanwälte</strong> erledigen alles Weitere für Sie und beraten Sie gerne jederzeit zu all Ihren Fragen!
            <br />
            <br />
          </TextCard>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextCard
            headingColor={"primary"}
            boxHeading={"Anwalt für Scheidung verpflichtend?"}
            boldText={
              "Wenn Sie sich mit Ihrem Partner einig sind, können Sie die sehr hohen Kosten für einen zweiten Anwalt vollständig einsparen und die Scheidungskosten untereinander aufteilen!"
            }
            textAlign={"center"}
          >
            Für eine Scheidung muss ein Anwalt beauftragt werden, weil für die Einreichung des Scheidungsantrags bei Gericht die Anwaltspflicht gilt. Wir
            übernehmen das für Sie und garantieren eine sehr gute Beratung, die genau auf Ihre Bedürfnisse ausgerichtet ist. Wenn Sie sich einvernehmlich
            scheiden lassen möchten, haben Sie zudem den Vorteil, dass nur ein Scheidungsanwalt benötigt wird.
            <br />
            <br />
          </TextCard>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AttorneyTextCards;
